class HeroVideo {
  constructor() {
    this.selectors = {
      play: '.js-hero-video-play',
      video: '.js-hero-video-full',
    };

    this.classes = {
      active: 'is-active',
    };

    this.init();
  }

  init() {
    const play = document.querySelector(this.selectors.play);
    const video = document.querySelector(this.selectors.video);
    if (play && video) {
      play.addEventListener('click', () => {
        video.classList.add(this.classes.active);
      });
    }
  }
}
export default new HeroVideo();
